import { toastr } from "react-redux-toastr";
import { doRequest } from "../../modules/request";
import { forceInt } from "../../utils/forceInt";

// Imports

export const RECEIVE_APOSTAS = "RECEIVE_APOSTAS";
export const CLEAN_APOSTAS = "CLEAN_APOSTAS";
export const RETRIEVED_APOSTA = "RETRIEVED_APOSTA";
export const CLOSE_APOSTA_DETAIL = "CLOSE_APOSTA_DETAIL";
export const REPEATED_APOSTA = "REPEATED_APOSTA";

export const receiveApostas = (payload) => ({
  type: RECEIVE_APOSTAS,
  payload: payload,
});

export const cleanApostas = (payload) => ({
  type: CLEAN_APOSTAS,
  payload: payload,
});

export const retrievedAposta = (payload) => ({
  type: RETRIEVED_APOSTA,
  payload: payload,
});

export const closeApostaDetail = (payload) => ({
  type: CLOSE_APOSTA_DETAIL,
  payload: payload,
});
export const recuperaApostasAPI = (objUser, aposta, callback) => {

  const data = {
    Cliente_ID: objUser.Cliente_ID,
    Site_ID: forceInt(objUser.Site_ID),
    CID: objUser.CID,
    chrSerial: aposta.chrSerial,
    intNumeroPule: aposta.intNumeroPule,
    vchETicket: aposta.vchETicket,
    Session_ID: objUser.Session_ID,
    vchGuidPreValidacao: aposta.vchGuidPreValidacao
  };

  const params = {
    url: "/BetListDetail",
    method: "POST",
    data: data,
  };

  return doRequest(params)
    .then((res) => {
      if(callback) callback(res);
    })
    .catch((error) => {
      console.error(error);
      if(callback) callback(error);
    });
};
export const recuperaApostas = (objUser, aposta, callback) => (dispatch, getState) => {

  const baseData = {
    Cliente_ID: objUser.Cliente_ID,
    Site_ID: forceInt(objUser.Site_ID),
    CID: objUser.CID,
    chrSerial: aposta.chrSerial,
    intNumeroPule: aposta.detail.arrJogo[0].intNumeroPule,
    vchETicket: aposta.detail.arrJogo[0].vchETicket,
    Session_ID: objUser.Session_ID,
    vchGuidPreValidacao: aposta.vchGuidPreValidacao
  }

  const baseRequest = {
    url: "/BetListDetail",
    method: "POST",
    data: baseData,
  };

  Promise.all(aposta.bilhetes.map((bilhete, i) => doRequest({
    url: "/BetListDetail",
    method: "POST",
    data: {
      ...baseData,
      intNumeroPule: bilhete.arrJogo ? bilhete.arrJogo[0].intNumeroPule : aposta.detail.arrJogo[0].intNumeroPule,
      vchETicket: bilhete.arrJogo ? bilhete.arrJogo[0].vchETicket : aposta.detail.arrJogo[0].vchETicket,
    }
  }))).catch(err => {
    console.error(err);
  });

  return doRequest(baseRequest)
    .then((res) => {
      if (res.isError) throw new Error(res.strErrorMessage);
      if (callback) callback(res);
      else dispatch(retrievedAposta(res));
    })
    .catch((error) => {
      throw new Error(error);
    });
};

export const betList = (ParamBetList, callback) => (dispatch, getState) => {
  const params = {
    url: "/BetList",
    method: "POST",
    data: ParamBetList,
  };

  return doRequest(params)
    .then((response) => {
      if (response.intCodigoRetorno > 0 || response.isError) {
        toastr.error("Atenção", response.strErrorMessage);
        dispatch(
          receiveApostas({
            arrJogos: [],
          })
        );
      } else {
        dispatch(receiveApostas(response));
      }
      callback(response);
    })
    .catch((error) => {
      toastr.error("Falha ao gerar eTicket.", error.message);
      callback(null);
    });
};



// WEBPACK FOOTER //
// ./src/reducers/relatorios/suasapostasActions.js